<div [hidden] = "formArray.controls.length == 0">
<h4>{{actionTitle | uppercase }}</h4>
<form [formGroup]="group" >
    <div [formArrayName]="controlName">
        
        <mat-accordion>
            <div class="accordion-div" *ngFor="let control of formArray.controls; let i = index"
                [formGroupName]="i">
                <mat-expansion-panel #panel class="expansion-panel"
                    [expanded]="i === formArray.controls.length-1 && formArray.controls.length === 1">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <span>{{control.get('name').value}}</span>
                        </mat-panel-title>
                        <mat-panel-description *ngIf="control.get('title').value as title; else notTitle" [ngClass]="title ? 'title' : ''" [matTooltip]="title">
                            <span>{{ title.substring(0, 100) + (title.length > 100 ? '...' : '') }}</span>
                            <mat-icon class="icon-left">book</mat-icon>
                        </mat-panel-description>
                        <ng-template #notTitle>
                            <mat-panel-description class="align-right">
                                <mat-icon>book</mat-icon>
                            </mat-panel-description>
                        </ng-template>
                    </mat-expansion-panel-header>

                    <div class="div-wrap">
                        <mat-form-field class="w100">
                            <mat-label>{{ 'DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.FIELDS.ELEMENTS.ID' |
                                translate
                                }}</mat-label>
                            <input matInput formControlName="name">
                        </mat-form-field>

                        <mat-form-field class="w100" *ngIf="formArrayGroup(i).get('title').value">
                            <mat-label>{{ 'DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.FIELDS.ELEMENTS.TITLE' |
                                translate
                                }}</mat-label>
                            <textarea matInput cdkTextareaAutosize formControlName="title"></textarea>
                        </mat-form-field>

                        <smt-search-select [group]="formArrayGroup(i)" [controlName]="'type'" [useChips] = "false"
                            [label]="'DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.FIELDS.MAIN_DATA.TYPE'"></smt-search-select>

                        <smt-search-select *ngIf="formArrayGroup(i).get('subtype').value"
                            [group]="formArrayGroup(i)" [controlName]="'subtype'" [useChips] = "false"
                            [label]="'DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.FIELDS.MAIN_DATA.SUBTYPE'"></smt-search-select>

                        <smt-search-select *ngIf="formArrayGroup(i).get('primaryApprovingBody').value"
                            [group]="formArrayGroup(i)" [controlName]="'primaryApprovingBody'" [useChips] = "false"
                            [label]="'DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.FIELDS.MAIN_DATA.PRIMARY_APPROVING_BODY'"></smt-search-select>

                        <smt-search-select *ngIf="formArrayGroup(i).get('secondaryApprovingBody').value"
                            [group]="formArrayGroup(i)" [controlName]="'secondaryApprovingBody'" [useChips] = "false"
                            [label]="'DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.FIELDS.MAIN_DATA.SECONDARY_APPROVING_BODY_SUB'"></smt-search-select>

                        <smt-search-select *ngIf="formArrayGroup(i).get('secondaryApprovingBodySub').value"
                            [group]="formArrayGroup(i)" [controlName]="'secondaryApprovingBodySub'" [useChips] = "false"
                            [label]="'DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.FIELDS.MAIN_DATA.SECONDARY_APPROVING_BODY_SUB'"></smt-search-select>

                        <mat-form-field class="w45">
                            <mat-label>{{ 'DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.FIELDS.MAIN_DATA.PROVISION_NUMBER' |
                                translate
                                }}</mat-label>
                            <input matInput formControlName="provisionNumber">
                        </mat-form-field>

                        <div class="w45">
                            <smt-search-select 
                                [group]="formArrayGroup(i)" [controlName]="'actionType'" [useChips] = "false"
                                [label]="'DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.FIELDS.MAIN_DATA.ACTION_TYPE'"></smt-search-select>
                        </div>

                        <div class="w45">
                            <smt-date-input
                                [group]="formArrayGroup(i)" [controlName]="'approvalDate'"
                                [label]="'DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.FIELDS.MAIN_DATA.APPROVAL_DATE'"></smt-date-input>
                        </div>

                        <div class="w45">
                            <smt-date-input
                                [group]="formArrayGroup(i)" [controlName]="'effectiveDate'"
                                [label]="'DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.FIELDS.MAIN_DATA.EFFECTIVE_DATE'"></smt-date-input>
                        </div>
                    </div>

                    <div class="action-buttons">
                        <button mat-raised-button color="primary" (click)="view(i)"
                            [matTooltip]="'DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.STEPS.ELEMENTS.VIEW_ITEM' | translate">
                            <mat-icon>visibility</mat-icon> {{ 'APP.ACTIONS.VIEW' | translate }}
                        </button>
                        <button *ngIf="!disabled" mat-raised-button color="warn" (click)="delete(i)"
                            [matTooltip]="'DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.STEPS.ELEMENTS.DELETE_ITEM' | translate">
                            <mat-icon>delete</mat-icon> {{ 'APP.ACTIONS.DELETE' | translate }}
                        </button>
                    </div>
                </mat-expansion-panel>
            </div>
        </mat-accordion>
    </div>
</form>
</div>